export default "/50f517735fec46580f19aae3e56e9fe21614ea75/ce82aae38e929df8fcdd7e760ce92d73.svg";